export default [

    {
        display: 'My Cases',
        link: '/mycases',
        active: 'mycases',
        visibility: 'all'
    },
    {
        display: 'Cases',
        link: '/case',
        active: 'cases',
        visibility: 'admin'
    },
    {
        display: 'Translators',
        link: '/translator',
        active: 'translators',
        visibility: 'admin'
    },
    {
        display: 'Onboarding',
        link: '/onboarding',
        active: 'onboarding',
        visibility: 'admin'
    },
]